import api from "./apiConfig";

export const REGISTER_EDO_CTA = async (data) => {
	try {
        const response = await api.post("/accountStatement", data);
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};

export const GET_EDO_CTA_ALL = async () => {
	try {
		const response = await api.get("/accountStatement");
		return response.data;
	} catch (error) {
		console.error("Error al obtener los edos de cuenta:", error);
		throw error;
	}
};

export const GET_EDO_CTA_BY_USER = async (id) => {
	try {
		const response = await api.get(`/accountStatement/properties/${id}`);
		return response.data;
	} catch (error) {
		console.error("Error al obtener los edos de cuenta:", error);
		throw error;
	}
};

export const UPDATE_EDO_CTA = async (id, data) => {
	try {
		const formData = new FormData();

		formData.append("file", data?.file);

		const response = await api.put(`/accountStatement/${id}`, formData, {
			headers: { "Content-Type": "multipart/form-data" },
		});
		return response.data;
	} catch (error) {
		console.error("Error al actualizar el edo cta:", error);
		throw error;
	}
};

export const UPDATE_EDO_CTA_STATUS = async (id, data) => {
	try {
		const formData = new FormData();

		formData.append("status", data?.status);
		formData.append("adminId", data?.adminId);

		const response = await api.put(`/accountStatement/${id}`, formData, {
			headers: { "Content-Type": "multipart/form-data" },
		});
		return response.data;
	} catch (error) {
		console.error("Error al actualizar el edo cta:", error);
		throw error;
	}
};